import { HostListener, Component, ViewChild,Input, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { ApiMethod } from '../../apimethods/api-method';
declare var $;
@Component({
    selector: 'app-pie-chart',
    templateUrl: './pie-chart.component.html',
    styleUrls: ['./pie-chart.component.css']
})
/** PieChart component*/
export class PieChartComponent implements OnInit {
  header :any;
  highchartsPie: typeof Highcharts = Highcharts; chartOptions; // initialization of the highchart component
  nPublisherId: any;

  constructor(private router: Router, http: HttpClient) {

       this.nPublisherId = localStorage.aPubID;
  
  }

  ngOnInit(): void {
    this.GetPieChartDetails();

  }

  public GetPieChartDetails(): void {
    $("#LoadingImage").show();

    var paramData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID
    
    };

    try {

      ApiMethod.postMethod('api/piechartDetails', paramData).subscribe(

        response => {
             $("#LoadingImage").hide();

          let CriticalStatus = response.CriticalStatus;
          let ChartData: any = [];
          

          $(CriticalStatus).each(function (index, val) {
            ChartData.push({ y: val.Count, name: val.CriticalStatus });
         
          });
         
          this.header = "Current Status Summary";
         
          this.LoadChartData(ChartData, this.header);
              $("#LoadingImage").hide();
        },
        error => {
              $("#LoadingImage").hide();
        }
      );
    } catch (e) {
      ngswal(e);
    }

  }
 
  // method to load the chart
   LoadChartData(ChartData, header): void {
    try {
      //Pie Chart
       this.highchartsPie = Highcharts;
       this.chartOptions = {    // defining the options to be displayed on the chart
        chart: {
          plotBorderWidth: null,
          plotShadow: false
        },
        title: {
          text: header,   // gets the title from parent component
        },
        //plotOptions: {
        //  pie: {
        //    allowPointSelect: true,
        //    cursor: 'pointer',
        //    dataLabels: {
        //      enabled: true,
        //      format: '<b>{point.name}</b>: {point.y}',
        //      style: {
        //        color: (Highcharts.theme) ||
        //          'black'
        //      }
        //    }
        //  }
        //},
        series: [{
          type: 'pie',
          name: "count",
          data: ChartData // gets the data from the parent component
        }]
      };


    } catch (e) {
   
      ngswal(e);
    }
  }
}
